import { Grid, Select, MenuItem } from "@mui/material";
import { Form } from "react-bootstrap";
import { DateRangePicker } from "shared/components/date/DateRangePicker";
import InputSearch from "shared/components/input/InputSearch";

interface CampoBuscaProps {
  onSearchChange: (search: string) => void;
  onStatusChange: (status: string) => void;
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void;
  status: string;
}

const CampoBusca: React.FC<CampoBuscaProps> = ({ onSearchChange, onStatusChange, onDateRangeChange, status }) => {
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={6}>
        <InputSearch
          id="search-condominios"
          label="Buscar"
          placeholder="Todos os condomínios e documentos"
          onSearchChange={onSearchChange}
          formStyle={{ height: "32px" }}
        />
      </Grid>
      <Grid item xs={3}>
        <DateRangePicker
          id="buscar-por-periodo"
          label="Buscar por período"
          onChange={(dates) => {
            onDateRangeChange(dates[0] ?? null, dates[1] ?? null);
          }}
          onClear={() => {
            onDateRangeChange(null, null);
          }}
          style={{ width: "100%" }}
          usarValidacaoParaFormulario={false}
        />
      </Grid>
      <Grid item xs={3}>
        <span className="label-input"> Status </span>
        <Form.Group style={{ height: "30px" }}>
          <Select
            labelId="status-ativacao-label"
            value={status}
            onChange={(e) => {
              onStatusChange(e.target.value);
            }}
            sx={{ width: "100%", height: "32px", fontSize: "0.875rem" }}
          >
            <MenuItem value="TODOS">Todos</MenuItem>
            <MenuItem value="ASSINADO">Assinado</MenuItem>
            <MenuItem value="RECUSADO">Assinatura recusada</MenuItem>
            <MenuItem value="PENDENTE">Assinatura pendente</MenuItem>
            <MenuItem value="EXPIRADO">Prazo expirado</MenuItem>
            <MenuItem value="CANCELADO">Cancelado</MenuItem>
          </Select>
        </Form.Group>
      </Grid>
    </Grid>
  );
};

export default CampoBusca;
